import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const useBuzonesStore = defineStore('buzones', {
  state: () => ({
    buzones: [],
    loading: false,
    error: null,
    search: '',
    perPage: 20,
    page: 1,
    currentPage: 1,
    totalBuzones: 0,
    totalPages: 1
  }),
  actions: {
    async fetchBuzones({ page, rows, search, perPage, fecha = null } = {}) {
      this.loading = true
      try {
        const response = await api.get('/buzones', {
          headers: {
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            page: page || this.page,
            rows: rows || this.rows,
            search: search || this.search,
            per_page: perPage || this.perPage,
            fecha: fecha || null
          }
        })
        this.buzones = response.data.items
        this.totalBuzones = response.data.total
        this.totalPages = response.data.pages
        this.perPage = response.data.per_page
        this.page = response.data.page
        return this.buzones
      } catch (error) {
        this.error = error
        console.error('Error al obtener buzones:', error)
        throw error
      } finally {
        this.loading = false
      }
    },
    async createBuzon(buzon) {
      try {
        const response = await api.post('/buzones', buzon, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.buzones.push(response.data)
        return response.data
      } catch (error) {
        this.error = error
        console.error('Error al crear buzón:', error)
        throw error
      }
    },
    async updateBuzon(buzon) {
      try {
        const response = await api.put(`/buzones/${buzon.id}`, buzon, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        const index = this.buzones.findIndex((b) => b.id === buzon.id)
        if (index !== -1) {
          this.buzones[index] = response.data
        }
        return response.data
      } catch (error) {
        this.error = error
        console.error('Error al actualizar buzón:', error)
        throw error
      }
    },
    async deleteBuzon(id) {
      try {
        await api.delete(`/buzones/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.buzones = this.buzones.filter((b) => b.id !== id)
      } catch (error) {
        this.error = error
        console.error('Error al eliminar buzón:', error)
        throw error
      }
    },
    setSearch(search) {
      this.search = search
    },
    setRows(rows) {
      this.rows = rows
    },
    setPage(page) {
      this.page = page
    },
    async getBuzon(id) {
      try {
        const response = await api.get(`/buzones/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data
      } catch (error) {
        console.error('Error al obtener buzón:', error)
        throw error
      }
    }
  }
})
